import { c as _c } from "react/compiler-runtime";
import useCartLoading from '@/contexts/cartContext/hooks/useCartLoading';
import useCartMainButton from '@/contexts/cartContext/hooks/useCartMainButton';
import useCartValidateCart from '@/contexts/cartContext/hooks/useCartValidateCart';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { FFormIdEnum } from '@/types/form';
import { FGA4ConfirmBookingErrorTypeEnum } from '@/types/gtm';
import sendGTMConfirmBookingFailed from '@/utils/gtm/sendGTMConfirmBookingFailed';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { useEffect, useState } from 'react';
import useIsValidationStep from '../../context/hooks/useIsValidationStep';
import useTunnelBookingType from '../../context/hooks/useTunnelBookingType';
const COMMON_CLASS_NAME = 'btn-primary !px-4 !py-3 xxs:!py-4';
const CartMainButton = t0 => {
    const $ = _c(18);
    const { sideSticky, ref } = t0;
    const loadingCart = useCartLoading();
    const validateCart = useCartValidateCart();
    const { mainButtonLabel } = useCartMainButton();
    const bookingType = useTunnelBookingType();
    const isValidationStep = useIsValidationStep();
    const formId = isValidationStep ? FFormIdEnum.CART_VALIDATION : "";
    const { isFormInError, setShowFormErrors, loadingFormErrors } = usePageFormErrors(formId);
    const className = `${COMMON_CLASS_NAME} ${sideSticky ? "self-stretch m-6 mt-2 !py-4" : "min-w-30 !py-3"}`;
    const disabledButton = !!formId && (loadingFormErrors || isFormInError);
    let t1;
    if ($[0] !== bookingType || $[1] !== formId || $[2] !== setShowFormErrors) {
        t1 = formId ? () => {
            setShowFormErrors(true);
            setTimeout(() => {
                const errors = Array.from(document.querySelectorAll("[data-form-field=\"true\"][data-form-error=\"true\"]")).map(_temp).join("; ");
                const errorMsg = `${FGA4ConfirmBookingErrorTypeEnum.form_errors} : ${errors != "" ? errors : "unknown error"}`;
                sendGTMConfirmBookingFailed(new Error(errorMsg), bookingType);
            }, 100);
        } : undefined;
        $[0] = bookingType;
        $[1] = formId;
        $[2] = setShowFormErrors;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const handleDisabledClick = t1;
    const [wasClicked, setWasClicked] = useState(false);
    let t2;
    let t3;
    if ($[4] !== loadingCart) {
        t2 = () => {
            if (!loadingCart) {
                setWasClicked(false);
            }
        };
        t3 = [loadingCart];
        $[4] = loadingCart;
        $[5] = t2;
        $[6] = t3;
    }
    else {
        t2 = $[5];
        t3 = $[6];
    }
    useEffect(t2, t3);
    let t4;
    if ($[7] !== validateCart) {
        t4 = () => {
            setWasClicked(true);
            validateCart();
        };
        $[7] = validateCart;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    const handleNextClick = t4;
    const t5 = !wasClicked;
    let t6;
    if ($[9] !== className || $[10] !== disabledButton || $[11] !== handleDisabledClick || $[12] !== handleNextClick || $[13] !== loadingCart || $[14] !== mainButtonLabel || $[15] !== ref || $[16] !== t5) {
        t6 = <Button title={mainButtonLabel} ref={ref} busy={loadingCart} hideBusyWheel={t5} disabled={disabledButton} onClick={handleNextClick} className={className} onDisabledClick={handleDisabledClick}>{mainButtonLabel}</Button>;
        $[9] = className;
        $[10] = disabledButton;
        $[11] = handleDisabledClick;
        $[12] = handleNextClick;
        $[13] = loadingCart;
        $[14] = mainButtonLabel;
        $[15] = ref;
        $[16] = t5;
        $[17] = t6;
    }
    else {
        t6 = $[17];
    }
    return t6;
};
export default CartMainButton;
function _temp(elem) {
    let elemId = elem.querySelector("label")?.getAttribute("for");
    if (elemId) {
        const match = /^cartValidation-(.*)-field$/gi.exec(elemId);
        elemId = match && match.length > 1 ? match[1] : elemId;
    }
    else {
        elemId = "unknown-element";
    }
    return `${elemId} => ${elem.querySelector("p.text-error")?.textContent ?? "unknown-error"}`;
}
